const asFeature = flag => flag === undefined || flag === null ? undefined : {
  enabled: !!flag
};
const fromLimited = lf => {
  var _lf$limit;
  return lf ? {
    enabled: lf.isApplied,
    quotaLimit: (_lf$limit = lf.limit) == null ? void 0 : _lf$limit.toString()
  } : undefined;
};
export const legacyToSettingsFeatures = legacy => ({
  bookingsAppointments: asFeature(legacy == null ? void 0 : legacy.applicableForIndividual),
  bookingsCourses: asFeature(legacy == null ? void 0 : legacy.applicableForCourse),
  bookingsGroups: asFeature(legacy == null ? void 0 : legacy.applicableForGroups),
  bookingsPayments: asFeature(legacy == null ? void 0 : legacy.applicableForPayments),
  bookingsReminders: asFeature(legacy == null ? void 0 : legacy.applicableForReminders),
  bookingsSmsReminders: asFeature(legacy == null ? void 0 : legacy.applicableForSmsReminders),
  bookingsExternalCalendars: asFeature(legacy == null ? void 0 : legacy.applicableForExternalCalendars),
  bookingsStaffLimit: fromLimited(legacy == null ? void 0 : legacy.bookingsStaffMembersLimit),
  bookingsServiceList: fromLimited(legacy == null ? void 0 : legacy.bookingsServicesLimit),
  anywhereRemoveBrand: asFeature(legacy == null ? void 0 : legacy.applicableForAnywhereBrandRemoval),
  anywhereCustomizationWidget: asFeature(legacy == null ? void 0 : legacy.applicableForAnywhereCustomizationWidget),
  bookingsVideoConferencing: asFeature(legacy == null ? void 0 : legacy.applicableForBookingsVideoConferencing)
});
//# sourceMappingURL=legacyToSettingsFeatures.js.map